import type { Locale } from '@/i18n'

const LOCALE_TAG: Record<Locale, string> = { id: 'id-ID', en: 'en-GB' }

/** `"13:23:48"` in the given IANA zone. */
export function formatTimeInZone(iso: string, timeZone: string, locale: Locale): string {
  return new Intl.DateTimeFormat(LOCALE_TAG[locale], {
    timeZone,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(new Date(iso))
}

/** `"2 Agustus 2027"` / `"2 August 2027"`. */
export function formatDate(iso: string, locale: Locale, timeZone?: string): string {
  return new Intl.DateTimeFormat(LOCALE_TAG[locale], {
    timeZone,
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(new Date(iso))
}

/** Full date and time in the visitor's own zone, with the zone name shown. */
export function formatInViewerZone(iso: string, locale: Locale): string {
  return new Intl.DateTimeFormat(LOCALE_TAG[locale], {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZoneName: 'short',
  }).format(new Date(iso))
}

/** The IANA zone the browser is running in, e.g. `"Asia/Jakarta"`. */
export function viewerTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

/** `21.4225, 39.8262` → `"21.4225°N, 39.8262°E"`. */
export function formatCoordinates(lat: number, lon: number): string {
  const ns = lat >= 0 ? 'N' : 'S'
  const ew = lon >= 0 ? 'E' : 'W'
  return `${Math.abs(lat).toFixed(4)}°${ns}, ${Math.abs(lon).toFixed(4)}°${ew}`
}
